module.exports = __webpack_public_path__ + "img/timer.574f20a3.svg";